import apiClient from './ApiClient';

export class CategoryRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/categories';
	}

	/**
	 * Get all categories
	 * @param {boolean} activeOnly - Filter to active categories only (default: true)
	 * @returns {Promise<Array>} Array of categories
	 */
	async list(activeOnly = true) {
		return this.client.get(this.basePath, { activeOnly });
	}

	/**
	 * Get category by ID
	 * @param {string} id - Category UUID
	 * @returns {Promise<Object>} Category object
	 */
	async getById(id) {
		return this.client.get(`${this.basePath}/${id}`);
	}

	/**
	 * Create a new category - Admin only
	 * @param {Object} payload
	 * @param {string} payload.name - Category name
	 * @param {string} payload.icon - Icon emoji or identifier
	 * @returns {Promise<{id: string}>}
	 */
	async create(payload) {
		return this.client.post(this.basePath, payload);
	}

	/**
	 * Update an existing category - Admin only
	 * @param {string} id - Category UUID
	 * @param {Object} payload
	 * @param {string} payload.name - Category name
	 * @param {string} payload.icon - Icon emoji or identifier
	 * @returns {Promise<{success: boolean}>}
	 */
	async update(id, payload) {
		return this.client.put(`${this.basePath}/${id}`, payload);
	}

	/**
	 * Delete (soft delete/deactivate) a category - Admin only
	 * @param {string} id - Category UUID
	 * @returns {Promise<{success: boolean, message: string}>}
	 */
	async delete(id) {
		return this.client.delete(`${this.basePath}/${id}`);
	}
}

export default new CategoryRepository(apiClient);
